The identifier for the `CandidateProcessHistoryItem` to be updated.
